import React, { useState, useEffect } from 'react';
import DevDetails from './DevDetails';
import moment from 'moment';
import { useFormikContext } from 'formik';
import comp from '../../../../images/icons/comp.svg';
import under_cons from '../../../../images/icons/under_cons.svg';
import headHome from '../../../../images/icons/headHome.svg';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import CommonDatePicker from '../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import { Append_0 } from '../../../../common/constants/Append_0';
import ToggleSelect from '../../../../common/components/ToggleSelect/ToggleSelect';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import { getLeadProertyDetails } from '../../../../common/constants/api';
import CircularLoading from '../../../../common/components/CircularLoading/CircularLoading';
import get from 'lodash/get';
import _ from 'lodash';
import PopUp from '../../../../common/components/PopUp/PopUp';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton';
import CommonKhataDesk from '../PropertyKhata/CommonKhataDesk';
import Seller from '../Seller/Seller';
import developer_icon from '../../../../images/icons/UserKycIcons/developer_icon.svg';

let devProgStatus = [
  {
    label: '0%',
    value: '0'
  },
  {
    label: '10%',
    value: '10'
  },
  {
    label: '20%',
    value: '20'
  },
  {
    label: '30%',
    value: '30'
  },
  {
    label: '40%',
    value: '40'
  },
  {
    label: '50%',
    value: '50'
  },
  {
    label: '60%',
    value: '60'
  },
  {
    label: '70%',
    value: '70'
  },
  {
    label: '80%',
    value: '80'
  },
  {
    label: '90%',
    value: '90'
  },
  {
    label: '100%',
    value: '100'
  }
];

const DevStatus = ({ formValues }) => {
  const [propValues, setPropValues] = useState(formValues);
  const [selectedOption, setSelectedOption] = useState('completed');
  const [leadAppicant_Id, setLeadApplicant_Id] = useState('');
  const [lead_Id, setLead_id] = useState('');
  const [popUpText, setPopUpText] = useState('');
  const [popUpType, setPopUpType] = useState('loading');
  const [showRadioAndBg, setShowRadioAndBg] = useState('');
  const [show, setShow] = useState(false);
  const [shouldShowSeller, setShouldShowSeller] = useState(false);
  const [goNext, setGoNext] = useState(false);
  const [showDeveloper, setShowDeveloper] = useState(false);
  const [showDevelopStatus, setShowDeveloperStatus] = useState(true);
  const [getData, setGetData] = useState('');

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    validateForm
  } = useFormikContext();

  function onClickCards(selectedPropertyTypeID) {
    if (selectedPropertyTypeID === '1') setFieldValue('plotType', 'new');
    else setFieldValue('plotType', 'resale');
    setShowRadioAndBg(selectedPropertyTypeID);
  }
  const getFormValues = formValues => {
    setFieldValue('developerName', formValues.developerName);
    setFieldValue('projName', formValues.projectName);
    setFieldValue('reraNo', formValues.RERA_Number);
  };
  useEffect(() => {
    setShowRadioAndBg('1');
  }, []);

  //for sellerComp handler
  useEffect(() => {
    if (
      values.plotType === 'resale' &&
      values.underDev &&
      values.itsPlotConstruction
    )
      setShouldShowSeller(true);
    else {
      setShouldShowSeller(false);
    }
  }, [values.plotType, values.underDev]);

  useEffect(() => {
    const InitialLoading = async () => {
      await setFieldValue('preValues', propValues);

      if (
        propValues?.loanType === 'New Purchase' &&
        propValues?.typeOfProperty === 'Independent House'
      ) {
        await setFieldValue('itsNewPurchase', true);
      }
      if (propValues?.loanType == 'Self Construction') {
        handleSubmit();
      }
      if (propValues?.loanType === 'Plot+Construction') {
        await setFieldValue('itsPlotConstruction', true);
      }
      if (
        propValues?.loanType === 'Balance Transfer' &&
        propValues?.typeOfProperty === 'Plot'
      ) {
        handleSubmit();
      }
      if (propValues?.loanType === 'Renovation/Improvement') {
        setShowDeveloper(true);
        setShowDeveloperStatus(false);
      }
      if (propValues?.loanType === 'Resale') {
        setShowDeveloper(false);
        setShouldShowSeller(true);
      } else {
        console.log('validating form');
        validateForm();
      }
    };

    InitialLoading();
  }, [propValues, values.underDev]);

  useEffect(() => {
    if (selectedOption === 'completed') {
      setFieldValue('completed', true);
      setFieldValue('underDev', false);
    } else {
      setFieldValue('underDev', true);
      setFieldValue('completed', false);
      validateForm();
    }
  }, [selectedOption]);

  useEffect(() => {
    let leadDetails = getApplicantionInfo();
    const { leadId, leadApplicantId } = leadDetails;
    setLead_id(leadId);
    setLeadApplicant_Id(leadApplicantId);
  }, []);

  //get api
  useEffect(() => {
    if (lead_Id) {
      setPopUpText('Loading.. ');
      setPopUpType('loading');
      setShow(true);
      getLeadProertyDetails(lead_Id)
        .then(res => {
          if (res) {
            // console.log(res);
            setGetData(res);
            if (res?.completionStatus) {
              if (propValues?.loanType === 'Renovation/Improvement') {
                setSelectedOption('completed');
              } else if (res.completionStatus.underDevelopment) {
                setSelectedOption('underDev');
              } else {
                setSelectedOption('completed');
              }
              setFieldValue(
                'completed',
                !res.completionStatus.underDevelopment
              );
              setFieldValue('underDev', res.completionStatus.underDevelopment);
              setFieldValue(
                'devPercentage.value',
                res.completionStatus.percentageCompleted
              );
              setFieldValue(
                'devPercentage.label',
                res.completionStatus.percentageCompleted
              );

              if (res?.completionStatus?.possessionDate) {
                let slicedDate = res.completionStatus.possessionDate.slice(
                  0,
                  10
                );
                const breakTheDate = slicedDate.toString().split('-');

                setFieldValue('prosDate.date', {
                  value: breakTheDate[2],
                  label: breakTheDate[2]
                });

                setFieldValue('prosDate.month', {
                  value: breakTheDate[1],
                  label: breakTheDate[1]
                });
                setFieldValue('prosDate.year', {
                  value: breakTheDate[0],
                  label: breakTheDate[0]
                });
              }
            }

            if (
              res.devDetails &&
              (propValues?.loanType !== 'New Purchase' ||
                propValues?.typeOfProperty !== 'Independent House')
            ) {
              setFieldValue('developerName', res.devDetails?.name || '');
              setFieldValue('projName', res.devDetails?.projectName || '');
              setFieldValue('reraNo', res.devDetails?.reraNumber || '');
            }
            setShow(false);
          }

          setTimeout(() => {
            validateForm();
          }, 1000);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }, [lead_Id]);

  return propValues?.loanType === 'Balance Transfer' &&
    propValues?.typeOfProperty === 'Plot' ? (
    <CircularLoading />
  ) : shouldShowSeller && goNext ? (
    <Seller
      getData={getData}
      sectionValues={values}
      setFormValues={getFormValues}
      submitHandler={handleSubmit}
      lead_Id={lead_Id}
      propValues={propValues}
    />
  ) : (
    <>
      <>
        <div className="mx-5 font-roboto font-normal  ">
          {propValues?.loanType !== 'Plot+Construction' ? (
            <div className="mb-2 font-roboto font-medium inline-flex mt-5 ">
              <img src={headHome} alt="home" />
              <p className="ml-3  self-end text-grey-920 text-base mt-1">
                {propValues?.typeOfProperty}
              </p>
            </div>
          ) : null}

          {propValues?.loanType === 'Plot+Construction' ? (
            <div className="">
              <p className="mb-3 font-roboto font-medium text-sm mt-2 text-black-1002">
                Is your Plot
              </p>
              <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 text-grey-920 pr-10 w-full max-w-xs">
                {/* new */}
                <div className="inline-flex md:block   ">
                  <div className="hidden md:block">
                    <CommonKhataDesk
                      id="1"
                      label="New"
                      onClickCards={onClickCards}
                      showRadioAndBg={showRadioAndBg}
                    >
                      <RadioButton
                        name="plotType"
                        value="new"
                        checked={values.plotType === 'new'}
                        onChange={e => {
                          setFieldValue('plotType', e.target.value);
                        }}
                      />
                    </CommonKhataDesk>
                  </div>
                  <p className="mr-auto md:hidden">New</p>
                  <div className="md:hidden">
                    <RadioButton
                      name="plotType"
                      onChange={e => {
                        setFieldValue('plotType', e.target.value);
                      }}
                      checked={values.plotType === 'new'}
                      value="new"
                    />
                  </div>
                </div>
                {/* resale */}
                <div className="inline-flex md:block ">
                  <div className="hidden md:block">
                    <CommonKhataDesk
                      id="2"
                      label="Resale"
                      onClickCards={onClickCards}
                      showRadioAndBg={showRadioAndBg}
                    >
                      <RadioButton
                        name="plotType"
                        value="resale"
                        checked={values.plotType === 'resale'}
                        onChange={e => {
                          setFieldValue('plotType', e.target.value);
                        }}
                      />
                    </CommonKhataDesk>
                  </div>
                  <p className="mr-auto md:hidden">Resale</p>
                  <div className="md:hidden">
                    <RadioButton
                      name="plotType"
                      onChange={e => {
                        setFieldValue('plotType', e.target.value);
                      }}
                      checked={values.plotType === 'resale'}
                      value="resale"
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {showDeveloper ? (
            <div className="w-full">
              <div className="inline-flex  text-grey-50 cursor-pointer mb-2 ">
                <div className=" mr-6">
                  <ToggleSelect
                    img={developer_icon}
                    name="progress"
                    value="completed"
                    checked={selectedOption === 'completed'}
                    onChange={e => {
                      setSelectedOption(e.target.value);
                    }}
                  />
                  <p
                    className={
                      (selectedOption === 'completed' ? 'text-teal ' : '') +
                      ' hover:text-teal mr-3 ml-4 mt-1 text-center'
                    }
                  >
                    Developer
                  </p>
                </div>
              </div>
            </div>
          ) : null}
          {showDevelopStatus ? (
            <>
              <p className="mb-2 font-roboto font-medium text-base mt-2 text-black-1002">
                {propValues?.typeOfProperty} Development Status
              </p>

              <div className="inline-flex  text-grey-50 cursor-pointer mb-2 ">
                <div className=" mr-6">
                  <ToggleSelect
                    img={comp}
                    name="progress"
                    value="completed"
                    checked={selectedOption === 'completed'}
                    onChange={e => {
                      setSelectedOption(e.target.value);
                    }}
                    // onBlur={}
                  />
                  <p
                    className={
                      (selectedOption === 'completed' ? 'text-teal ' : '') +
                      ' hover:text-teal mr-3 ml-4 mt-1 text-center'
                    }
                  >
                    Completed
                  </p>
                </div>
                <div>
                  <ToggleSelect
                    img={under_cons}
                    name="progress"
                    value="underDev"
                    checked={selectedOption === 'underDev'}
                    onChange={e => {
                      setSelectedOption(e.target.value);
                    }}
                  />
                  <p
                    className={
                      (selectedOption === 'underDev' ? 'text-teal ' : '') +
                      ' hover:text-teal mt-1 text-center'
                    }
                  >
                    Under Development
                  </p>
                </div>
              </div>
            </>
          ) : null}
          {selectedOption !== 'completed' ? (
            <>
              <div className="flex flex-col xl:flex-row justify-between flex-wrap mt-5 ">
                <div className="w-full xl:w-9/20 mt-5 xl:mt-0">
                  <label className="text-xs text-grey-50 -mt-2.5 z-10 bg-white absolute ml-4 block">
                    How much developed
                  </label>
                  <CommonSelect sort={true}
                    name="devPercentage"
                    value={values.devPercentage}
                    onChange={value => {
                      setFieldValue('devPercentage', {
                        value: value.value,
                        label: value.label
                      }),
                        setFieldTouched('devPercentage', true, false);
                    }}
                    onBlur={() => {
                      setFieldTouched('devPercentage', true, true);
                    }}
                    options={[...devProgStatus]}
                    stylesContainer={{
                      height: '52px',
                      fontSize: '40px'
                    }}
                    dropdownStyle={{
                      top: '55px'
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 25px'
                    }}
                    error={
                      touched.devPercentage &&
                      get(errors, 'devPercentage', false)
                    }
                    errorMsg={get(errors, 'devPercentage', false)}
                    touched={touched.devPercentage}
                  />
                </div>
                <div className="w-full xl:w-9/20 mt-5 xl:mt-0 ">
                  <p className="text-xs text-grey-50 relative mb-1 xl:mb-0 xl:absolute  xl:-mt-5  z-10">
                    Possesion Date
                  </p>

                  <CommonDatePicker
                    minYear={moment().format('YYYY')}
                    yearOptionsOrder="asce"
                    maxYear={moment()
                      .add(15, 'year')
                      .format('YYYY')}
                    styleHeight={{ height: '52px' }}
                    onChangeMonth={(value, isValidDate) => {
                      if (value.label !== 'Month') {
                        setFieldValue(
                          'prosDate.month',
                          {
                            value: Append_0(value.value, 2),
                            label: value.label
                          },
                          true
                        );
                        setFieldTouched('prosDate.month', true, false);
                      }
                      if (!isValidDate) {
                        setFieldValue(
                          'prosDate.month',
                          {
                            value: '',
                            label: 'Month'
                          },
                          true
                        );
                      }
                    }}
                    onChangeYear={(value, isValidDate) => {
                      if (value.label !== 'Year') {
                        setFieldValue(
                          'prosDate.year',
                          {
                            value: value.value,
                            label: value.label
                          },
                          true
                        );
                        setFieldTouched('prosDate.year', true, false);
                      }

                      if (!isValidDate) {
                        setFieldValue(
                          'prosDate.year',
                          {
                            value: '',
                            label: 'year'
                          },
                          true
                        );
                      }
                    }}
                    onChangeDate={value => {
                      if (value.label !== 'Date') {
                        setFieldValue(
                          'prosDate.date',
                          {
                            value: Append_0(value.value, 2),
                            label: value.label
                          },
                          true
                        );
                        setFieldTouched('prosDate.date', true, false);
                      }
                    }}
                    valueMonth={values.prosDate.month}
                    valueYear={values.prosDate.year}
                    valueDate={values.prosDate.date}
                    errorYear={
                      touched?.prosDate?.year &&
                      get(errors, 'prosDate.year', false)
                    }
                    touchedYear={touched?.prosDate?.year}
                    onBlurYear={() => {
                      setFieldTouched('prosDate.year', true, true);
                    }}
                    errorMonth={
                      touched?.prosDate?.month &&
                      get(errors, 'prosDate.month', false)
                    }
                    touchedMonth={touched?.prosDate?.month}
                    onBlurMonth={() => {
                      setFieldTouched('prosDate.month', true, true);
                    }}
                    errorDate={
                      touched?.prosDate?.date &&
                      get(errors, 'prosDate.date', false)
                    }
                    touchedDate={touched?.prosDate?.date}
                    onBlurDate={() => {
                      setFieldTouched('prosDate.date', true, true);
                    }}
                    errorMsg={
                      (touched?.prosDate?.date && errors['prosDate.date']) ||
                      (touched?.prosDate?.month && errors['prosDate.month']) ||
                      (touched?.prosDate?.month && errors['prosDate.year'])
                    }
                  />
                </div>
              </div>
            </>
          ) : null}
          {(propValues?.loanType === 'New Purchase' &&
            propValues?.typeOfProperty === 'Independent House') ||
          propValues?.loanType === 'Plot+Construction' ||
          propValues?.loanType === 'Resale' ? null : (
            <DevDetails />
          )}
          <div>
            <button
              disabled={!_.isEmpty(errors)}
              type={shouldShowSeller ? 'button' : 'submit'}
              className="submitButton w-56"
              onClick={() => {
                if (shouldShowSeller) setGoNext(true);
              }}
            >
              Next
            </button>
          </div>
          <PopUp
            type={popUpType}
            text={popUpText}
            setShow={setShow}
            show={show}
          />
        </div>
      </>
    </>
  );
};

export default React.memo(DevStatus);
